export const getContactTitle = ({ name, brokerageName }) => {
  const contact = name || ''
  const brokerage = brokerageName || ''

  return `${contact}${brokerage && ', ' + brokerage}`
}
